export default class UrlAPI {
  static getUrl(){
    return 'https://api-prod.meiaentrada.org.br'
  }
  static getUrlLambda(){
    return 'https://9wdekizvq4.execute-api.sa-east-1.amazonaws.com'
  }
  static getWordpressApiUrl(){
    // return "https://localhost/wp-json/wp/v2"
    return "https://www.une.org.br/wp-json/wp/v2"
  }
}




// WEBPACK FOOTER //
// ./src/components/UrlAPI.js